import React from 'react';
import Icon from '../../../components/AppIcon';

const BookingProgress = ({ currentStep }) => {
  const steps = [
    { id: 1, label: 'Service Details', icon: 'Car' },
    { id: 2, label: 'Passenger Info', icon: 'Users' },
    { id: 3, label: 'Payment', icon: 'CreditCard' },
    { id: 4, label: 'Confirmation', icon: 'CheckCircle' }
  ];

  return (
    <div className="w-full bg-card rounded-lg p-4 md:p-6 lg:p-8 shadow-sm mb-6 md:mb-8">
      <div className="flex items-center justify-between relative">
        <div className="absolute top-5 left-0 right-0 h-0.5 bg-muted -z-10">
          <div 
            className="h-full bg-primary transition-all duration-500"
            style={{ width: `${((currentStep - 1) / (steps?.length - 1)) * 100}%` }}
          />
        </div>

        {steps?.map((step, index) => (
          <div key={step?.id} className="flex flex-col items-center gap-2 relative z-10">
            <div
              className={`w-10 h-10 md:w-12 md:h-12 rounded-full flex items-center justify-center transition-all duration-300 ${
                currentStep > step?.id
                  ? 'bg-primary text-primary-foreground'
                  : currentStep === step?.id
                  ? 'bg-primary text-primary-foreground ring-4 ring-primary/20'
                  : 'bg-muted text-muted-foreground'
              }`}
            >
              {currentStep > step?.id ? (
                <Icon name="Check" size={20} strokeWidth={3} />
              ) : (
                <Icon name={step?.icon} size={18} />
              )}
            </div>
            <span
              className={`text-xs md:text-sm font-medium text-center whitespace-nowrap ${
                currentStep >= step?.id ? 'text-foreground' : 'text-muted-foreground'
              }`}
            >
              {step?.label}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BookingProgress;